import { Modal } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalValidationErrors } from '@hero/components/molecules';
import { useUploadAsset } from '@hero/services/merchant-service/hooks';

import { UPLOAD_LOGO_SCREEN } from './constants';
import { UploadLogoContext } from './context';
import { CropImage } from './CropImage';
import { PreviewImage } from './PreviewImage';
import * as S from './style';
import UploadImage from './UploadImage';

function UploadLogoModal({
  uploadAction,
  useCustomMutation,
  isOpen,
  setIsOpen,
  maxFiles = 1,
  disabled = false,
  children,
  titlei18Key = 'uploadYourLogoOptional'
}) {
  const { t } = useTranslation();
  const useUpload = useCustomMutation || useUploadAsset;

  const pageLayoutContentRef = useRef(null);

  const [currentScreen, setCurrentScreen] = useState(UPLOAD_LOGO_SCREEN.upload);
  const [modalProps, setModalProps] = useState({
    primaryButtonProps: {
      onClick: () => {
        setIsOpen(false);
      }
    }
  });
  const [cropImage, setCropImage] = useState();
  const [previewImage, setPreviewImage] = useState();
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState();

  const screens = {
    [UPLOAD_LOGO_SCREEN.upload]: UploadImage,
    [UPLOAD_LOGO_SCREEN.crop]: CropImage,
    [UPLOAD_LOGO_SCREEN.preview]: PreviewImage
  };

  const Component = screens[currentScreen];

  return (
    <S.UploadLogoModal>
      {children}
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        title={t(titlei18Key)}
        {...modalProps}
      >
        <ModalValidationErrors pageLayoutContentRef={pageLayoutContentRef} />
        <UploadLogoContext.Provider
          value={{
            crop,
            setCrop,
            status,
            cropImage,
            setCropImage,
            isOpen,
            setIsOpen,
            maxFiles,
            disabled,
            useUpload,
            setCurrentScreen,
            modalProps,
            setModalProps,
            setPreviewImage,
            previewImage,
            uploadAction,
            completedCrop,
            setCompletedCrop
          }}
        >
          <Component />
        </UploadLogoContext.Provider>
      </Modal>
    </S.UploadLogoModal>
  );
}

UploadLogoModal.propTypes = {
  uploadAction: PropTypes.func,
  useCustomMutation: PropTypes.func,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
  maxFiles: PropTypes.number,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  titlei18Key: PropTypes.string
};

export { UploadLogoModal };
